import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { PlaceOfDeathInput } from '../../../BasePersonInputs/PlaceOfDeath/PlaceOfDeathInput';

export function PlaceOfDeathField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <PlaceOfDeathInput
      value={value as string}
      onChange={onChange}
      label='Auflösungsort'
    />
  );
}
